module.exports = __webpack_public_path__ + "static/img/8areaA_13.82abcf8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/文字バージョン/8areaA_13.png
// module id = 980
// module chunks = 1